<template>
	<div class="layout-container">
		<div class="sidebar-component">
			<Sidebar />
		</div>
		<div class="left-container">
			<div class="topbar">
				<Topbar />
				<div class="title-container-top">
					<span class="title-icon" v-html="pageIconSvg"></span>
					<p>{{ title }}</p>
				</div>
			</div>
			<div class="content">
				<div class="contdainer">
					<router-view />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Sidebar from './Sidebar.vue';
import Topbar from './Topbar.vue';
export default {
	name: 'layout',
	components: {
		Sidebar,
		Topbar,
	},

	computed: {
		title() {
			return this.$route.meta.title;
		},
		pageIconSvg() {
			const icons = {
				dashboard: '<rect x="3" y="3" width="7" height="7" rx="1.6"/><rect x="14" y="3" width="7" height="7" rx="1.6"/><rect x="14" y="14" width="7" height="7" rx="1.6"/><rect x="3" y="14" width="7" height="7" rx="1.6"/>',
				users: '<circle cx="9" cy="8" r="3.2"/><path d="M3.5 20c0-3.2 2.7-5 5.5-5s5.5 1.8 5.5 5"/><path d="M16 4.6a3 3 0 0 1 0 6.8"/><path d="M17 15c2.4.4 4 2.1 4 5"/>',
				report: '<line x1="4" y1="20" x2="4" y2="12"/><line x1="10" y1="20" x2="10" y2="4"/><line x1="16" y1="20" x2="16" y2="9"/><line x1="21.5" y1="20" x2="2.5" y2="20"/>',
				store: '<path d="M4 4h16l1 5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z"/><path d="M5 11.5V20h14v-8.5"/><path d="M10 20v-5h4v5"/>',
				warehouse: '<path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/>',
				survey: '<rect x="6" y="4" width="12" height="17" rx="2"/><path d="M9 4.5V3.5h6v1"/><path d="M9 12l1.6 1.6L14 10"/>',
				visit: '<path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
				ticket: '<path d="M21 12a8 8 0 0 1-11.5 7.2L4 21l1.9-5.4A8 8 0 1 1 21 12z"/>',
				setting: '<circle cx="12" cy="12" r="3"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.2 5.2l2.1 2.1M16.7 16.7l2.1 2.1M18.8 5.2l-2.1 2.1M7.3 16.7l-2.1 2.1"/>',
				file: '<path d="M6 2.5h7l5 5v14H6z"/><path d="M13 2.5v5h5"/>',
				action: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1"/>',
				infraction: '<path d="M12 3.5l8.5 15H3.5z"/><line x1="12" y1="10" x2="12" y2="14"/><circle cx="12" cy="16.7" r="0.7"/>',
				instruction: '<path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z"/><path d="M4 19V5"/>',
				supervision: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
				pic: '<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.5" cy="10" r="1.8"/><path d="M4 18l5-5 3.5 3.5L16 13l4 4"/>',
				verify: '<path d="M12 3l7 3v6c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/>',
				iot: '<rect x="7" y="7" width="10" height="10" rx="2"/><path d="M10 3v3M14 3v3M10 18v3M14 18v3M3 10h3M3 14h3M18 10h3M18 14h3"/>',
			};
			const inner = icons[this.pageIconKey] || icons.dashboard;
			return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>';
		},
		pageIconKey() {
			const p = (this.$route.path || '').toLowerCase();
			const n = (this.$route.name || '').toLowerCase();
			const s = p + ' ' + n;
			const has = (...k) => k.some((x) => s.includes(x));
			if (has('dashboard')) return 'dashboard';
			if (has('user')) return 'users';
			if (has('report')) return 'report';
			if (has('survey')) return 'survey';
			if (has('visit')) return 'visit';
			if (has('supervis')) return 'supervision';
			if (has('store', 'shop', 'outlet')) return 'store';
			if (has('warehouse', 'ware')) return 'warehouse';
			if (has('ticket', 'feedback')) return 'ticket';
			if (has('setting')) return 'setting';
			if (has('file')) return 'file';
			if (has('action')) return 'action';
			if (has('infraction')) return 'infraction';
			if (has('instruction')) return 'instruction';
			if (has('pic', 'image', 'photo')) return 'pic';
			if (has('verify', 'identification')) return 'verify';
			if (has('iot')) return 'iot';
			return 'dashboard';
		},
	},
	data() {
		return {
			closeMenu: false,
		};
	},
};
</script>

<style lang="scss" scoped>
.layout-container {
	display: flex;
	.left-container {
		overflow-y: scroll;
		height: 100vh;
		width: 100%;
		background: var(--lema-content-bg);
	}
	.topbar {
		width: 100%;
		.title-container-top {
			width: 100%;
			height: 52px;
			background: #ffffff;
			border-bottom: 1px solid var(--lema-border);
			display: flex;
			align-items: center;
			gap: 11px;
			padding: 8px 24px;
			box-shadow: 0 2px 10px rgba(15, 26, 46, 0.04);
			.title-icon {
				width: 32px;
				height: 32px;
				flex-shrink: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 9px;
				color: #2d8b8b;
				background: rgba(45, 139, 139, 0.10);
				::v-deep svg {
					width: 19px;
					height: 19px;
				}
			}
			p {
				color: var(--lema-ink);
				font-weight: 700;
				font-size: 15px;
				text-align: right;
				margin-bottom: 0;
			}
		}
	}
}
.content {
	background-color: var(--lema-content-bg);
	.contdainer {
		min-height: calc(100vh - 132px);
		padding: 22px 24px;
	}
}
</style>
